
/**
 * Clase responsable de procesar 
 * la respuesta del servidor SBSuite
 *
 * @export
 * @class SBSuiteResponse
 */
export class SBSuiteResponse{


    /**
     * Indica el estado de la respuesta
     * 
     * 0 si la respuesta és correcta
     * 
     * >0 si la respuesta és un error
     * 
     *
     * @private
     * @type {number}
     * @memberof SBSuiteResponse
     */
    private _status: number = -1;


    /**
     * Contiene el contenido de la respuesta o de el mensaje de error
     *
     * @private
     * @type {*}
     * @memberof SBSuiteResponse
     */
    private _data: any = {};


    /**
     * Crea la instancia de SBSuiteResponse.
     * 
     * @param {*} [params={}] Respuesta de la API.
     * @memberof SBSuiteResponse
     */
    constructor(params: any = {}){
        if(typeof params.status != 'undefined'){
            if(typeof params.status != 'number' ) this._status = parseInt(params.status);
            else this._status = params.status;
        } 
        if(typeof params.data != 'undefined') this._data = params.data;

        if(typeof this._status != 'number'){
            this._status = -1;
            this._data['msg'] = "Bad response"
        } 
    }


    /**
     * Devuelve los datos de la respuesta.
     *
     * @returns
     * @memberof SBSuiteResponse
     */
    getData(){
        return this._data;
    }


    /**
     * Devuelve el mensaje de error si es error.
     *
     * @returns
     * @memberof SBSuiteResponse
     */
    getErrorMessage(){
        return this.isError()?this._data.msg:null;
    }


    /**
     * True si és error (campo status diferente de 0).
     * False en caso contrario.
     *
     * @returns
     * @memberof SBSuiteResponse
     */
    isError(){
        return this._status!==0 ?true:false;
    }


    /**
     * 
     * True si el mensaje és un error no previsto (campo status menor que 0).
     * False en caso contrario.
     *
     * @returns
     * @memberof SBSuiteResponse
     */
    isUnknownError(){
        return this._status<0?true:false;
    }

}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/sbsuite-response.model.ts